<template>
  <ul class="transition_link">
    <li :class="navFuntions.activeNavCls('home')">
      <a href="#home" @click.prevent="navFuntions.activeSection('home')">{{
        t.nav.home
      }}</a>
    </li>
    <li :class="navFuntions.activeNavCls('services')">
      <a
        href="#services"
        @click.prevent="navFuntions.activeSection('services')"
        >{{ t.nav.services }}</a
      >
    </li>
    <li :class="navFuntions.activeNavCls('projects')">
      <a
        href="#projects"
        @click.prevent="navFuntions.activeSection('projects')"
        >{{ t.nav.projects }}</a
      >
    </li>

    <li :class="navFuntions.activeNavCls('contact')">
      <a href="#contact" @click.prevent="navFuntions.activeSection('contact')">{{
        t.nav.contact
      }}</a>
    </li>

    <li>
      <a
        href="https://soporte.datamindss.com"
        target="_blank"
        rel="noopener"
        >{{ t.nav.support }}</a
      >
    </li>
  </ul>
</template>

<script>
import { i18n } from "@/i18n";
import { navFuntions } from "@/navFuntions";
export default {
  name: `Menu`,
  data() {
    return {
      navFuntions,
    };
  },
  computed: {
    t() {
      return i18n.m;
    },
  },
};
</script>
